import React, { useEffect } from "react";
import { FaWhatsapp, FaInstagram, FaFacebookF, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "../styles/Contato.css";

const Contato = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div className="contato-page">
            <div className="page-hero">
                <div className="page-hero__overlay" />
                <div className="page-hero__content">
                    <h1 className="page-hero__title">Contato</h1>
                    <div className="page-breadcrumbs">
                        <span className="page-breadcrumbs__link">Início</span>
                        <span className="page-breadcrumbs__sep">›</span>
                        <span className="page-breadcrumbs__current">Contato</span>
                    </div>
                </div>
            </div>

            <section className="about">
                <div className="about-container">
                    <div className="about-header">
                        <h2>Entre em Contato</h2>
                        <p>
                            A <strong>ROS Dormentes</strong> está à disposição para orçamentos, dúvidas ou parcerias.
                            Fale conosco através de nossos canais oficiais ou venha nos visitar.
                        </p>
                    </div>

                    <div className="about-content contato-blocos">
                        <div className="contato-info">
                            <div className="contato-item">
                                <FaMapMarkerAlt className="contato-icon" />
                                <h3>Endereço</h3>
                                <p>
                                    Rua Analia Lancetti Randi, 37.A<br />
                                    Bom Pastor, São João del Rei - MG<br />
                                    CEP: 36305-276
                                </p>
                            </div>

                            <div className="contato-item">
                                <FaPhoneAlt className="contato-icon" />
                                <h3>Telefones</h3>
                                <p>(32) 99110-0949<br />(32) 99977-7220</p>
                            </div>

                            <div className="contato-item">
                                <FaEnvelope className="contato-icon" />
                                <h3>E-mail</h3>
                                <p>rosdormentes@hotmail.com</p>
                            </div>
                        </div>

                        <div className="contato-acao">
                            <a
                                href="https://wa.me/5532991100949?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20produtos%20ROS%20Dormentes."
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-whatsapp"
                            >
                                <FaWhatsapp /> Falar no WhatsApp
                            </a>

                            <div className="contato-social">
                                <h3>Siga-nos</h3>
                                <div className="social-links">
                                    <a
                                        href="https://www.instagram.com/rosdormentesdormentes"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaInstagram />
                                    </a>
                                    <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">
                                        <FaFacebookF />
                                    </a>
                                    <a href="mailto:rosdormentes@hotmail.com">
                                        <FaEnvelope />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mapa */}
                    <div className="contato-mapa">
                        <h3>Como Chegar</h3>
                        <div className="mapa-embed">
                            <iframe
                                title="Mapa ROS Dormentes"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3754.097948228887!2d-44.237357523971015!3d-21.132361877193094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa1e3d8ac1b4b2d%3A0x5b2ac1f94e4b2b12!2sR.%20An%C3%A1lia%20Lancetti%20Randi%2C%2037%20-%20Bom%20Pastor%2C%20S%C3%A3o%20Jo%C3%A3o%20del%20Rei%20-%20MG%2C%2036305-276!5e0!3m2!1spt-BR!2sbr!4v1695736400000!5m2!1spt-BR!2sbr"
                                width="100%"
                                height="400"
                                style={{ border: 0, borderRadius: "12px" }}
                                allowFullScreen=""
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contato;
